export const FILTER_OPTIONS = [
  { id: 'none', name: 'Original' },
  { id: 'sepia', name: 'Sepia' },
  { id: 'grayscale', name: 'Grayscale' },
  { id: 'vintage', name: 'Vintage' },
  { id: 'pixelate', name: 'Pixelate' },
  { id: 'brightness', name: 'Brightness' },
  { id: 'saturation', name: 'Saturation' },
  { id: 'contrast', name: 'Contrast' },
  { id: 'blur', name: 'Blur' },
  { id: 'sharpen', name: 'Sharpen' },
];
